// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__199Oo","title":"Header_title__11b2h","left":"Header_left__3lOd5","clinicName":"Header_clinicName__1CP78"};